import { DateTime } from "luxon";
import React from "react";

import { costPerConditionsDatapoint } from "../../weathersv";

const ConditionsFundStatus = ({ channel, audbsv }) => {
  const activeDays = Math.round(
    Math.max(
      0,
      DateTime.fromISO(channel.status.active_until)
        .diff(DateTime.utc())
        .as("days") || 0
    )
  );

  const purchaseTopup = async () => {
    const FIFTY_CENTS = 0.5;
    const qty = Math.floor(
      (FIFTY_CENTS * audbsv * 100_000_000) / costPerConditionsDatapoint
    );

    const orderResponse = await fetch("/api/orders", {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            productId: "TOPUP_CONDITIONS",
            quantity: qty.toString(),
            data: { channelId: channel.id },
          },
        ],
      }),
    });

    if (!orderResponse.ok) {
      if (orderResponse.status === 401) {
        // redirect to login
        window.location.href = `${
          window.location.origin
        }/login?ref=${encodeURIComponent(window.location.pathname)}`;
      }

      // TODO: display error
      return;
    }

    const order = await orderResponse.json();

    window.location.href = `${window.location.origin}/orders/${order.id}`;
  };

  return (
    <div style={{ flexBasis: "100%" }}>
      <h4 style={{ padding: "4px" }}>Conditions</h4>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div style={{ margin: "auto 0", padding: "4px" }}>
          {activeDays.toLocaleString()} Days Remaining
        </div>
        {activeDays < 365 * 3 && (
          <div onClick={purchaseTopup} className="btn primary">
            Topup
          </div>
        )}
      </div>
    </div>
  );
};

export default ConditionsFundStatus;
